var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.67901698 2.36068252 4.80858805 4.71399016 6.92578125 7.578125 C6.01828125 8.3 5.11078125 9.021875 4.17578125 9.765625 C1.34650074 12.11783713 -0.8164686 14.664899 -3.07421875 17.578125 C-6.32090296 21.00030565 -9.77617486 24.06090358 -13.375 27.09765625 C-14.89577293 28.42265152 -16.33547144 29.83937769 -17.76171875 31.265625 C-19.77519407 33.27910032 -21.783614 34.90477795 -24.07421875 36.578125 C-25.05519531 35.876875 -26.03617188 35.175625 -27.046875 34.453125 C-55.60693367 14.26430273 -86.10618388 5.11594756 -121.38671875 10.640625 C-144.88875686 14.85014371 -167.19768992 26.78420115 -181.34130859 46.32910156 C-199.70083079 72.76077827 -203.57279761 105.20373443 -198.48217773 136.57080078 C-195.41390372 153.54096559 -188.55800654 170.54513243 -177.07421875 183.578125 C-176.09388672 184.78855469 -176.09388672 184.78855469 -175.09375 186.0234375 C-159.77636227 204.27038026 -136.15942172 213.50305427 -112.94921875 216.296875 C-88.91199403 218.04151228 -66.07728262 215.21821194 -44.32421875 204.515625 C-43.65632324 204.18731689 -42.98842773 203.85900879 -42.30029297 203.52075195 C-38.61020926 201.61969905 -35.6261068 199.8664802 -33.07421875 196.578125 C-32.61354311 193.22561572 -32.61354311 193.22561572 -32.90234375 189.4453125 C-32.93019958 188.73577423 -32.95805542 188.02623596 -32.98675537 187.29519653 C-33.07981834 185.01316441 -33.20064374 182.73368976 -33.32421875 180.453125 C-34.03248988 165.46865902 -34.07421875 150.61163525 -34.07421875 135.578125 C-58.49421875 135.248125 -82.91421875 134.918125 -108.07421875 134.578125 C-108.07421875 120.718125 -108.07421875 106.858125 -108.07421875 92.578125 C-104.77341309 92.58336182 -101.47260742 92.58859863 -98.07177734 92.59399414 C-87.16733306 92.61056207 -76.26288822 92.62160909 -65.35843468 92.62993717 C-58.74692494 92.6351563 -52.1354281 92.6422364 -45.52392578 92.65356445 C-39.14378355 92.66442772 -32.76365373 92.67040916 -26.38350296 92.67300224 C-23.94905019 92.67485027 -21.5145981 92.67845897 -19.0801506 92.68385506 C-15.67109458 92.69111106 -12.26208985 92.692114 -8.85302734 92.69165039 C-7.34251297 92.6970433 -7.34251297 92.6970433 -5.80148315 92.70254517 C-1.10950747 92.69563806 3.31146432 92.55581249 7.92578125 91.578125 C8.84621281 94.70996677 9.04933435 97.50766266 9.04603577 100.7666626 C9.04809776 102.33994324 9.04809776 102.33994324 9.05020142 103.94500732 C9.04660614 105.0901178 9.04301086 106.23522827 9.03930664 107.41503906 C9.03945267 108.62506592 9.03959869 109.83509277 9.03974915 111.08178711 C9.03917207 114.39551862 9.03415852 117.70918774 9.02717519 121.02290821 C9.02092176 124.48758065 9.02033627 127.95225394 9.01914978 131.41693115 C9.01604234 137.97584309 9.00783685 144.53473835 8.99780029 151.09364295 C8.98662094 158.56154778 8.98112411 166.02945341 8.97610486 173.49736452 C8.96565376 188.85762767 8.94806566 204.21787418 8.92578125 219.578125 C7.93578125 219.908125 6.94578125 220.238125 5.92578125 220.578125 C5.59578125 221.568125 5.26578125 222.558125 4.92578125 223.578125 C3.10719292 225.232473 1.31626801 226.72314734 -0.63671875 228.203125 C-1.21172119 228.64043945 -1.78672363 229.07775391 -2.37915039 229.52832031 C-38.65706156 256.41089693 -85.31397807 262.06737065 -129.07421875 256.578125 C-165.42288567 250.94477354 -199.80746365 233.22768204 -221.91137695 203.29907227 C-229.67281251 192.40546189 -238.10832734 179.77382829 -241.07421875 166.578125 C-241.61175781 164.83595703 -241.61175781 164.83595703 -242.16015625 163.05859375 C-254.73008244 121.82161475 -251.57301144 76.11675871 -231.76171875 37.765625 C-227.630546 30.0588054 -222.74768391 23.21556965 -217.07421875 16.578125 C-216.63851562 16.06411133 -216.2028125 15.55009766 -215.75390625 15.02050781 C-190.74201126 -14.17831989 -154.96613252 -29.97332962 -117.05517578 -33.2277832 C-74.24153664 -36.01540344 -33.87689919 -27.18429366 0 0 Z ",
    fill: "#010101",
    transform: "translate(610.07421875,367.421875)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.81433577 -0.00085442 1.62867154 -0.00170885 2.46768415 -0.00258917 C5.21158152 -0.00424359 7.95541851 0.0012768 10.6993103 0.00672913 C12.66017149 0.00701103 14.62103279 0.0068532 16.58189392 0.00628662 C21.91839134 0.00599878 27.25486645 0.01189338 32.59135866 0.01886058 C38.16342335 0.02509631 43.73548851 0.02569809 49.30755615 0.02688599 C59.86499435 0.02999865 70.42242224 0.03821117 80.9798559 0.04823548 C92.99660092 0.05939862 105.01334642 0.06490757 117.03009534 0.06993091 C141.7549644 0.08039383 166.47981932 0.09873852 191.2046814 0.12025452 C191.2046814 13.98025452 191.2046814 27.84025452 191.2046814 42.12025452 C174.27876386 42.36982044 174.27876386 42.36982044 166.88046265 42.47572327 C161.89623406 42.54708021 156.91201274 42.61878329 151.92782593 42.69300842 C122.13015937 43.13581306 92.37811136 43.17758819 62.5796814 42.62025452 C53.5459314 42.45525452 44.5121814 42.29025452 35.2046814 42.12025452 C35.2046814 68.52025452 35.2046814 94.92025452 35.2046814 122.12025452 C40.1546814 121.62525452 40.1546814 121.62525452 45.2046814 121.12025452 C47.83941117 121.05658294 50.47554139 121.03378432 53.1109314 121.05775452 C53.80231201 121.06154114 54.49369263 121.06532776 55.20602417 121.06922913 C57.37231302 121.0812552 59.5384558 121.09990982 61.7046814 121.12025452 C64.59009388 121.14683068 67.47544311 121.16677408 70.3609314 121.18275452 C72.26068726 121.20015686 72.26068726 121.20015686 74.19882202 121.21791077 C77.12883939 121.33231484 77.12883939 121.33231484 79.2046814 120.12025452 C79.2046814 120.78025452 79.2046814 121.44025452 79.2046814 122.12025452 C85.71930461 122.00282999 92.23375521 121.87799566 98.74813843 121.74794006 C100.96555336 121.70455374 103.18300251 121.66288143 105.40048218 121.62294006 C108.58271612 121.56532698 111.76477724 121.50160687 114.9468689 121.43666077 C115.94274017 121.41994827 116.93861145 121.40323578 117.96466064 121.38601685 C118.88546417 121.36607162 119.8062677 121.3461264 120.75497437 121.32557678 C121.5677182 121.3100325 122.38046204 121.29448822 123.21783447 121.2784729 C125.27906406 121.23923038 125.27906406 121.23923038 127.2046814 120.12025452 C127.2046814 120.78025452 127.2046814 121.44025452 127.2046814 122.12025452 C128.16769165 122.08472473 129.1307019 122.04919495 130.12289429 122.0125885 C133.72148564 121.88147609 137.32032019 121.7585836 140.91928101 121.63807678 C142.47209279 121.5849547 144.02483166 121.52965188 145.57748413 121.47206116 C147.81894206 121.3893107 150.06055162 121.3146023 152.30233765 121.24134827 C152.98804337 121.2143132 153.67374908 121.18727814 154.38023376 121.15942383 C158.80582916 121.02470112 162.85957493 121.38660095 167.2046814 122.12025452 C167.22932915 127.65613985 167.24751635 133.19199352 167.25961304 138.72792053 C167.26465384 140.61269181 167.27148638 142.49745916 167.28012085 144.38221741 C167.29219757 147.08527087 167.29791208 149.78827282 167.30233765 152.49134827 C167.30749893 153.33926437 167.31266022 154.18718048 167.31797791 155.06079102 C167.31817334 157.0809652 167.2667435 159.10103386 167.2046814 161.12025452 C166.2046814 162.12025452 166.2046814 162.12025452 164.03575802 162.24330235 C163.07064076 162.24238055 162.10552351 162.24145876 161.11116028 162.24050903 C159.45571701 162.24257103 159.45571701 162.24257103 157.76683044 162.24467468 C156.54547897 162.24107941 155.3241275 162.23748413 154.06576538 162.23377991 C152.78790161 162.23392593 151.51003784 162.23407196 150.19345093 162.23422241 C146.67914549 162.23451037 143.1648739 162.22861392 139.65057635 162.22164845 C135.98168784 162.21541464 132.31279863 162.2148111 128.64390564 162.21362305 C121.69177704 162.21050981 114.7396641 162.20229653 107.7875424 162.19227356 C98.39635878 162.17902686 89.0051709 162.17361245 79.61398029 162.16777134 C64.81086893 162.15835664 50.0077906 162.13843767 35.2046814 162.12025452 C35.5346814 188.85025452 35.8646814 215.58025452 36.2046814 243.12025452 C87.6846814 243.12025452 139.1646814 243.12025452 192.2046814 243.12025452 C192.2046814 282.12025452 192.2046814 282.12025452 191.2046814 285.12025452 C124.8746814 285.12025452 58.5446814 285.12025452 -9.7953186 285.12025452 C-9.7953186 191.40025452 -9.7953186 97.68025452 -9.7953186 1.12025452 C-6.6903941 -0.43220774 -3.40730134 -0.01291513 0 0 Z ",
    fill: "#010101",
    transform: "translate(152.79531860351563,335.87974548339844)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.94074875 0.00007553 1.8814975 0.00015106 2.85075378 0.00022888 C3.86333755 0.00539017 4.87592133 0.01055145 5.91918945 0.01586914 C6.95815872 0.01728409 7.99712799 0.01869904 9.06758118 0.02015686 C12.38924018 0.02575884 15.71083203 0.03831167 19.0324707 0.05102539 C21.28312077 0.05604014 23.5337719 0.06060309 25.78442383 0.06469727 C31.30462907 0.0757289 36.82479509 0.09246896 42.3449707 0.11352539 C46.93277077 8.92013355 50.86695675 17.91954431 54.5949707 27.11352539 C55.19625137 28.58611911 55.7979909 30.05852554 56.40014648 31.53076172 C57.69770473 34.70529617 58.99255161 37.88091778 60.28540039 41.05737305 C62.41607762 46.29093988 64.55556983 51.52087822 66.6965332 56.75024414 C67.44507843 58.57877192 68.19361351 60.40730385 68.94213867 62.23583984 C69.50405914 63.60852524 69.50405914 63.60852524 70.07733154 65.00894165 C71.61188801 68.75869074 73.14513578 72.50897433 74.67837524 76.25926208 C79.26780217 87.48470951 83.86573969 98.7066425 88.4699707 109.92602539 C88.95938141 111.11861465 88.95938141 111.11861465 89.4586792 112.33529663 C91.09804953 116.32995072 92.73758536 120.32453686 94.37719727 124.3190918 C97.0323849 130.78807941 99.68636441 137.25756258 102.34033203 143.72705078 C103.67594162 146.98281518 105.01172502 150.23850819 106.34765625 153.49414062 C109.34007523 160.78686437 112.33173653 168.07989378 115.3192749 175.37461853 C122.49968794 192.90698911 129.70701722 210.42766729 136.9699707 227.92602539 C142.12958771 240.35695838 147.28568357 252.78927415 152.41497803 265.23275757 C153.02956585 266.72348699 153.64450901 268.21406997 154.25982666 269.70449829 C155.10172886 271.74406752 155.94230826 273.7841765 156.7824707 275.82446289 C157.25555664 276.97221191 157.72864258 278.11996094 158.21606445 279.30249023 C158.9848464 281.21679719 159.69262135 283.15647732 160.3449707 285.11352539 C159.65870605 285.13858154 158.97244141 285.1636377 158.26538086 285.18945312 C155.16671253 285.30523966 152.06836147 285.42804424 148.9699707 285.55102539 C147.88973633 285.5903418 146.80950195 285.6296582 145.6965332 285.67016602 C144.6652832 285.71206055 143.6340332 285.75395508 142.5715332 285.79711914 C141.61843262 285.83377686 140.66533203 285.87043457 139.68334961 285.90820312 C137.32364721 285.97116005 137.32364721 285.97116005 135.3449707 287.11352539 C135.3449707 286.45352539 135.3449707 285.79352539 135.3449707 285.11352539 C134.59812012 285.12399902 133.85126953 285.13447266 133.08178711 285.14526367 C129.71121562 285.18673309 126.34069771 285.21282268 122.9699707 285.23852539 C121.7943457 285.2552832 120.6187207 285.27204102 119.4074707 285.28930664 C118.28598633 285.29575195 117.16450195 285.30219727 116.0090332 285.30883789 C114.97214355 285.31931152 113.93525391 285.32978516 112.86694336 285.34057617 C110.3449707 285.11352539 110.3449707 285.11352539 108.3449707 283.11352539 C107.5546875 281.2409668 107.5546875 281.2409668 106.79418945 278.96508789 C106.51027344 278.12953369 106.22635742 277.29397949 105.93383789 276.43310547 C105.63638672 275.54389404 105.33893555 274.65468262 105.0324707 273.73852539 C102.98074964 267.76254014 100.93087389 261.79773341 98.5949707 255.92602539 C98.22887695 255.0043457 97.8627832 254.08266602 97.4855957 253.13305664 C96.45250648 250.776858 96.45250648 250.776858 93.3449707 250.11352539 C93.0149707 249.45352539 92.6849707 248.79352539 92.3449707 248.11352539 C93.3349707 248.11352539 94.3249707 248.11352539 95.3449707 248.11352539 C94.99710362 246.13815794 94.99710362 246.13815794 94.3449707 244.11352539 C93.6849707 243.78352539 93.0249707 243.45352539 92.3449707 243.11352539 C91.5637207 241.22290039 91.5637207 241.22290039 90.8449707 238.86352539 C90.03004573 236.25742015 89.20120733 233.7654667 88.1574707 231.23852539 C87.3449707 229.11352539 87.3449707 229.11352539 87.3449707 226.11352539 C86.3549707 225.78352539 85.3649707 225.45352539 84.3449707 225.11352539 C85.0049707 225.11352539 85.6649707 225.11352539 86.3449707 225.11352539 C85.6849707 223.13352539 85.0249707 221.15352539 84.3449707 219.11352539 C41.1149707 219.11352539 -2.1150293 219.11352539 -46.6550293 219.11352539 C-49.80029992 225.32519582 -49.80029992 225.32519582 -52.57446289 231.63916016 C-52.8951474 232.43101212 -53.21583191 233.22286407 -53.54623413 234.03871155 C-53.87862091 234.86906418 -54.21100769 235.69941681 -54.5534668 236.55493164 C-54.91090973 237.44027084 -55.26835266 238.32561005 -55.6366272 239.23777771 C-56.77086215 242.04928898 -57.90050478 244.86261889 -59.0300293 247.67602539 C-59.77973016 249.53617202 -60.52972786 251.39619905 -61.2800293 253.25610352 C-65.41062503 263.49971697 -65.41062503 263.49971697 -69.49584961 273.76147461 C-69.91382309 274.81600075 -69.91382309 274.81600075 -70.34024048 275.89183044 C-71.07837968 277.75644959 -71.81336082 279.62231804 -72.5480957 281.48828125 C-73.6550293 284.11352539 -73.6550293 284.11352539 -74.6550293 285.11352539 C-76.189859 285.20671988 -77.72895012 285.23098339 -79.26660156 285.22705078 C-80.24754288 285.22697525 -81.22848419 285.22689972 -82.239151 285.2268219 C-83.3058049 285.22166061 -84.3724588 285.21649933 -85.47143555 285.21118164 C-87.10072243 285.20905922 -87.10072243 285.20905922 -88.76292419 285.20689392 C-92.24782005 285.20127587 -95.73265271 285.18872032 -99.2175293 285.17602539 C-101.57364816 285.17101272 -103.92976803 285.16644941 -106.28588867 285.16235352 C-112.07562394 285.15130058 -117.86532211 285.1345449 -123.6550293 285.11352539 C-122.17780623 280.49720329 -120.44531872 276.01869549 -118.5925293 271.54321289 C-118.28943848 270.80636261 -117.98634766 270.06951233 -117.67407227 269.31033325 C-117.01576298 267.71051803 -116.3565499 266.11107447 -115.6965332 264.51196289 C-114.26330449 261.03942374 -112.83445083 257.56508941 -111.40527344 254.09088135 C-110.64817555 252.25057826 -109.89084721 250.41036996 -109.13330078 248.57025146 C-105.33531155 239.34333171 -101.55773915 230.10810356 -97.78250122 220.87185669 C-91.27031994 204.93997132 -84.74477467 189.01362021 -78.20788574 173.09185791 C-73.64761299 161.98369445 -69.1079397 150.86745971 -64.5859375 139.74365234 C-61.39121403 131.89510849 -58.15368371 124.06487792 -54.9050293 116.23852539 C-50.14264078 104.76027109 -45.44679404 93.25596172 -40.7800293 81.73852539 C-40.46714966 80.96655823 -40.15427002 80.19459106 -39.83190918 79.39923096 C-39.21934316 77.88735988 -38.60707447 76.37536831 -37.99511719 74.86325073 C-37.40451267 73.40408291 -36.81321817 71.94519414 -36.22119141 70.48660278 C-34.77049188 66.90540561 -33.34090605 63.31783733 -31.94702148 59.71411133 C-31.53913895 58.66796158 -31.53913895 58.66796158 -31.12301636 57.60067749 C-30.38098169 55.69338038 -29.64641691 53.78318192 -28.91235352 51.87280273 C-27.6550293 49.11352539 -27.6550293 49.11352539 -25.6550293 48.11352539 C-25.29828928 46.45171149 -24.97007765 44.78374496 -24.6550293 43.11352539 C-23.86262444 41.07629532 -23.02679486 39.05557936 -22.1550293 37.05102539 C-20.71653501 33.73496153 -19.52575483 30.61058565 -18.6550293 27.11352539 C-17.95619843 25.49591291 -17.22312604 23.89291367 -16.4675293 22.30102539 C-14.89608314 18.93494216 -13.41974056 15.56386602 -12.09643555 12.09399414 C-11.83564209 11.41377197 -11.57484863 10.7335498 -11.30615234 10.03271484 C-10.79428375 8.68453122 -10.29161097 7.33281528 -9.79882812 5.97753906 C-9.16726512 4.32208827 -8.41890516 2.71223826 -7.6550293 1.11352539 C-4.77540096 0.15364928 -2.98875489 -0.00801275 0 0 Z M17.3449707 56.11352539 C12.88462123 65.4370018 8.93738399 74.89840862 5.13937378 84.50534058 C3.41092715 88.87649749 1.66995558 93.24267147 -0.0690918 97.60961914 C-0.43553299 98.53067947 -0.80197418 99.45173981 -1.17951965 100.40071106 C-5.65175123 111.63379287 -10.18417429 122.84250599 -14.7175293 134.05102539 C-15.51009418 136.01244995 -16.30265609 137.9738757 -17.09521484 139.93530273 C-17.85598137 141.81634794 -18.61680365 143.6973706 -19.37768555 145.57836914 C-19.74051132 146.47656372 -20.1033371 147.3747583 -20.47715759 148.3001709 C-22.21645125 152.5975712 -23.97244176 156.88658696 -25.76782227 161.16088867 C-26.09689072 161.94726212 -26.42595917 162.73363556 -26.76499939 163.5438385 C-27.37910551 165.00759194 -27.99760953 166.46951128 -28.62135315 167.92918396 C-29.83769709 170.83103211 -30.6550293 172.93188892 -30.6550293 176.11352539 C-18.0009165 176.89396476 -5.41365044 177.25272222 7.26293945 177.21118164 C8.98456277 177.209309 10.70618662 177.20788912 12.42781067 177.20689392 C16.88770098 177.2031352 21.34755701 177.19336455 25.80743408 177.18218994 C30.38699887 177.1718301 34.96656937 177.16736558 39.54614258 177.16235352 C48.47910008 177.15173395 57.41203251 177.13474103 66.3449707 177.11352539 C65.65308791 172.61520944 64.58154499 168.78829872 62.8684082 164.56274414 C62.49916733 163.64501976 62.49916733 163.64501976 62.12246704 162.70875549 C61.32746277 160.73709685 60.52388694 158.76906498 59.7199707 156.80102539 C59.17000377 155.44217322 58.62052655 154.08312275 58.0715332 152.72387695 C54.69883892 144.38597317 51.29662214 136.05968666 47.8449707 127.75415039 C45.02769499 120.91638746 42.31178037 114.04000529 39.6184082 107.15258789 C39.1440332 105.93958008 38.6696582 104.72657227 38.1809082 103.47680664 C37.44497883 101.59450676 36.70963009 99.71198854 35.97583008 97.82885742 C35.25424136 95.9777634 34.53010827 94.12766184 33.8059082 92.27758789 C33.38100098 91.18913574 32.95609375 90.10068359 32.51831055 88.97924805 C31.84436566 87.33322952 31.13691576 85.69832537 30.34008789 84.1081543 C29.0293256 81.48084126 28.01067991 78.77768794 26.9621582 76.03540039 C26.51743164 74.87524414 26.07270508 73.71508789 25.61450195 72.51977539 C25.15430664 71.31321289 24.69411133 70.10665039 24.2199707 68.86352539 C23.75204102 67.64149414 23.28411133 66.41946289 22.80200195 65.16040039 C21.64784627 62.14546309 20.49557471 59.12981953 19.3449707 56.11352539 C18.6849707 56.11352539 18.0249707 56.11352539 17.3449707 56.11352539 Z ",
    fill: "#010101",
    transform: "translate(755.655029296875,335.886474609375)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0 10.56 0 16 0 C16 0.33 16 0.66 16 1 C10.72 1 5.44 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#2A292A",
    transform: "translate(254,622)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8 0.33 8 0.66 8 1 C5.36 1 2.72 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#29292A",
    transform: "translate(240,622)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.33 7 0.66 7 1 C4.69 1 2.38 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#2A2A2A",
    transform: "translate(286,622)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#303030",
    transform: "translate(665,622)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#2A2B2B",
    transform: "translate(295,622)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#2A2A2A",
    transform: "translate(217,622)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#2D2D2E",
    transform: "translate(176,622)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#303031",
    transform: "translate(672,622)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#2F2F31",
    transform: "translate(656,622)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#2C2B2C",
    transform: "translate(312,622)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#2A2A2B",
    transform: "translate(280,622)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#2A292A",
    transform: "translate(200,622)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#2B2B2B",
    transform: "translate(192,622)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C1.34 3.67 0.68 3.34 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#242424",
    transform: "translate(803,468)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#2E2D2D",
    transform: "translate(323,622)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#2B2C2C",
    transform: "translate(302,622)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#2B2A2B",
    transform: "translate(249,622)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#2A292A",
    transform: "translate(230,622)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#303030",
    transform: "translate(161,622)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#313131",
    transform: "translate(153,622)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#2A292A",
    transform: "translate(500,497)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#302F31",
    transform: "translate(334,622)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#2B2A2A",
    transform: "translate(275,622)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#29292A",
    transform: "translate(271,622)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#302F2E",
    transform: "translate(170,622)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#232323",
    transform: "translate(0,0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#222122",
    transform: "translate(0,0)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#202220",
    transform: "translate(0,0)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#323132",
    transform: "translate(616,457)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#202120",
    transform: "translate(786,425)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323032",
    transform: "translate(883,622)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#313132",
    transform: "translate(880,622)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323231",
    transform: "translate(643,622)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#313031",
    transform: "translate(339,622)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#302F2F",
    transform: "translate(331,622)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#2D2D2D",
    transform: "translate(320,622)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#2C2B2C",
    transform: "translate(307,622)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#2A2A2A",
    transform: "translate(235,622)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#2B292B",
    transform: "translate(227,622)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#2A2A2A",
    transform: "translate(214,622)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#2B292A",
    transform: "translate(206,622)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#2D2C2B",
    transform: "translate(187,622)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2A2929",
    transform: "translate(0,0)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#282728",
    transform: "translate(850,588)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282626",
    transform: "translate(0,0)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#222021",
    transform: "translate(0,0)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252325",
    transform: "translate(0,0)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#242424",
    transform: "translate(0,0)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#272527",
    transform: "translate(532,503)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282728",
    transform: "translate(0,0)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#292929",
    transform: "translate(0,0)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#212122",
    transform: "translate(0,0)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#272729",
    transform: "translate(207,456)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#212121",
    transform: "translate(0,0)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#232322",
    transform: "translate(0,0)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#222120",
    transform: "translate(0,0)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#222022",
    transform: "translate(0,0)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#262829",
    transform: "translate(0,0)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#272627",
    transform: "translate(538,380)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#2B292A",
    transform: "translate(577,346)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#2B2A2B",
    transform: "translate(557,338)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5D5D5D",
    transform: "translate(0,0)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3C3B",
    transform: "translate(0,0)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343735",
    transform: "translate(0,0)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343333",
    transform: "translate(0,0)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353133",
    transform: "translate(0,0)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3132",
    transform: "translate(0,0)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353533",
    transform: "translate(0,0)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303133",
    transform: "translate(0,0)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3030",
    transform: "translate(0,0)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313232",
    transform: "translate(0,0)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303031",
    transform: "translate(0,0)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323231",
    transform: "translate(0,0)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313132",
    transform: "translate(0,0)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343132",
    transform: "translate(0,0)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2C2A2A",
    transform: "translate(0,0)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D2C2B",
    transform: "translate(0,0)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#302F2D",
    transform: "translate(0,0)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#292C2C",
    transform: "translate(0,0)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#292929",
    transform: "translate(0,0)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2C2B2D",
    transform: "translate(0,0)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2C2A2A",
    transform: "translate(0,0)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D2B2B",
    transform: "translate(0,0)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2E2D2E",
    transform: "translate(0,0)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2E2C2E",
    transform: "translate(0,0)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#302F2E",
    transform: "translate(0,0)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343536",
    transform: "translate(0,0)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2C2A2B",
    transform: "translate(0,0)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2C2A2A",
    transform: "translate(0,0)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3A3B",
    transform: "translate(0,0)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323234",
    transform: "translate(0,0)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A393B",
    transform: "translate(0,0)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#292A2A",
    transform: "translate(0,0)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2B2B2B",
    transform: "translate(0,0)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#292727",
    transform: "translate(0,0)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2B2A2A",
    transform: "translate(0,0)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252527",
    transform: "translate(0,0)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#29292A",
    transform: "translate(0,0)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282827",
    transform: "translate(0,0)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#292826",
    transform: "translate(0,0)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#262626",
    transform: "translate(0,0)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282827",
    transform: "translate(0,0)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282827",
    transform: "translate(0,0)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282928",
    transform: "translate(0,0)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282526",
    transform: "translate(0,0)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282729",
    transform: "translate(0,0)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#272627",
    transform: "translate(0,0)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2A2B2E",
    transform: "translate(0,0)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#292827",
    transform: "translate(0,0)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282626",
    transform: "translate(0,0)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252926",
    transform: "translate(0,0)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252328",
    transform: "translate(0,0)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#262528",
    transform: "translate(0,0)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282627",
    transform: "translate(0,0)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252526",
    transform: "translate(0,0)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282526",
    transform: "translate(0,0)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282628",
    transform: "translate(0,0)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#28282A",
    transform: "translate(0,0)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#272626",
    transform: "translate(0,0)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#222323",
    transform: "translate(0,0)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#242623",
    transform: "translate(0,0)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252322",
    transform: "translate(0,0)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282626",
    transform: "translate(0,0)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#262526",
    transform: "translate(0,0)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#232425",
    transform: "translate(0,0)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#201F23",
    transform: "translate(0,0)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252622",
    transform: "translate(0,0)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#232423",
    transform: "translate(0,0)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#242425",
    transform: "translate(0,0)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#262626",
    transform: "translate(0,0)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#232325",
    transform: "translate(0,0)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252525",
    transform: "translate(0,0)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252526",
    transform: "translate(0,0)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#292628",
    transform: "translate(0,0)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#242323",
    transform: "translate(0,0)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#232223",
    transform: "translate(0,0)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#262224",
    transform: "translate(0,0)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252525",
    transform: "translate(0,0)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#272626",
    transform: "translate(0,0)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2C2C2B",
    transform: "translate(0,0)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#29282A",
    transform: "translate(0,0)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#232222",
    transform: "translate(0,0)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D2C2C",
    transform: "translate(0,0)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2C2A2B",
    transform: "translate(0,0)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2A2929",
    transform: "translate(0,0)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282627",
    transform: "translate(0,0)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#242427",
    transform: "translate(0,0)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#28292A",
    transform: "translate(0,0)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#272629",
    transform: "translate(0,0)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#232524",
    transform: "translate(0,0)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252425",
    transform: "translate(0,0)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#262425",
    transform: "translate(0,0)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#232222",
    transform: "translate(0,0)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2B2A2B",
    transform: "translate(0,0)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252326",
    transform: "translate(0,0)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#222221",
    transform: "translate(0,0)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282627",
    transform: "translate(0,0)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#242726",
    transform: "translate(0,0)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D2C2C",
    transform: "translate(0,0)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D2E2D",
    transform: "translate(0,0)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#272728",
    transform: "translate(0,0)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2C292C",
    transform: "translate(0,0)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2B2B2C",
    transform: "translate(0,0)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D2A2B",
    transform: "translate(0,0)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2D2D",
    transform: "translate(0,0)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D2A29",
    transform: "translate(0,0)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252524",
    transform: "translate(0,0)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#242525",
    transform: "translate(0,0)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#232424",
    transform: "translate(0,0)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#292928",
    transform: "translate(0,0)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252425",
    transform: "translate(0,0)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252525",
    transform: "translate(0,0)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252325",
    transform: "translate(0,0)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#242325",
    transform: "translate(0,0)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#272626",
    transform: "translate(0,0)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#242427",
    transform: "translate(0,0)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252626",
    transform: "translate(0,0)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#242426",
    transform: "translate(0,0)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#222421",
    transform: "translate(0,0)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#202220",
    transform: "translate(0,0)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#272729",
    transform: "translate(0,0)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282725",
    transform: "translate(0,0)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#242224",
    transform: "translate(0,0)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282828",
    transform: "translate(0,0)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#27272A",
    transform: "translate(0,0)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#232326",
    transform: "translate(0,0)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282B2B",
    transform: "translate(0,0)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#252625",
    transform: "translate(0,0)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#262527",
    transform: "translate(0,0)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2C2C2C",
    transform: "translate(0,0)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282A2A",
    transform: "translate(0,0)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#262626",
    transform: "translate(0,0)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313432",
    transform: "translate(0,0)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282626",
    transform: "translate(0,0)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#28292A",
    transform: "translate(0,0)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D2D2F",
    transform: "translate(0,0)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#292826",
    transform: "translate(0,0)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#292929",
    transform: "translate(0,0)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2A2C2B",
    transform: "translate(0,0)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F2F",
    transform: "translate(0,0)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D2B2B",
    transform: "translate(0,0)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2C2A29",
    transform: "translate(0,0)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282728",
    transform: "translate(0,0)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2A2625",
    transform: "translate(0,0)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2B2D2A",
    transform: "translate(0,0)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2C2B2B",
    transform: "translate(0,0)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2B2B28",
    transform: "translate(0,0)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2B282C",
    transform: "translate(0,0)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#302F2F",
    transform: "translate(0,0)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F6F70",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEga);
export default __webpack_public_path__ + "static/media/ega.6dfaee433a01d1677a1c47d070820ac0.svg";
export { ForwardRef as ReactComponent };